<template>
  <AssistMessageInput v-if="isAssistConversation" @onSubmit="$emit('onSubmit', $event)" />

  <div v-else class="inputs-wrapper" :class="{ 'inputs-disabled': inputsDisabled }">
    <InputDisabledBannerInfo v-if="inputsDisabled" :info-text="resolvedDisabledInfoText" />
    <InputField :is-disabled="inputsDisabled" v-model="sharedValueChat" @onSubmit="onSubmit" />
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { marked } from 'marked';

import { Routes } from '~/constants/routes';

import AssistMessageInput from '~/components/conversation/AssistMessageInput.vue';
import InputField from '~/components/conversation/InputField.vue';
import InputDisabledBannerInfo from '~/components/conversation/InputDisabledBannerInfo.vue';
import { useSanitize } from '~/composables/useSanitize';
import useAuthoring from '~/composables/useAuthoring';

// Dispatches between the Assist input (tabs, prompt cards, filters — AssistMessageInput.vue)
// and the plain Authoring input, based on route. Authoring stays on the old agent for the
// foreseeable future, so its input has none of Assist's new-agent-adjacent complexity.
export default {
  components: {
    AssistMessageInput,
    InputField,
    InputDisabledBannerInfo,
  },
  emits: ['onSubmit'],
  setup(props, { emit }) {
    const route = useRoute();
    const { sanitize } = useSanitize(true);
    const { isAuthoringInputDisabled } = useAuthoring();

    const isAssistConversation = route.name === Routes.Conversation.name;

    const inputsDisabled = computed(() => isAuthoringInputDisabled.value);
    const resolvedDisabledInfoText = 'collections.collectionNotFound';

    const sharedValueChat = ref('');
    const onSubmit = () => {
      const sanitizedInput = sanitize(marked(sharedValueChat.value));
      emit('onSubmit', sanitizedInput);
    };

    return {
      isAssistConversation,
      inputsDisabled,
      resolvedDisabledInfoText,
      sharedValueChat,
      onSubmit,
    };
  },
};
</script>

<style scoped lang="scss">
.inputs-disabled {
  pointer-events: none;
  position: relative;
}

.inputs-wrapper {
  margin-top: $bb-spacing-2;
}
</style>
